//Resumo.js
import React from 'react'
import { Text, View, Linking } from 'react-native'
import styles from './Styles.js'

//const border = 1;

const Resumo = () => {
  return (
    <View>
      <Text> </Text>
      <Text style={styles.titleText}>Professor particular de todas as matérias do ensino fundamental e médio, e exatas para superior.</Text>
      <Text style={styles.titleText}>Especialista em International Baccalaureate Diploma Programme.</Text>
      <Text style={styles.titleText}>Matemática, física, química, biologia, português, literatura, inglês, geografia, história, sociologia, filosofia, estatística, cálculo, resistência dos materiais.</Text>
      <Text style={styles.titleText}>Com 25 anos de experiência lecionando para crianças, adolescentes e jovens.</Text>
      <Text style={styles.titleText}>Aulas em domicílios de Alphaville e região.</Text>
      <Text> </Text>
      <View style={styles.row}>
        <View style={{borderWidth: border, width: '50%'}}>
        </View>
        <View style={{borderWidth: border, width: '50%', borderLeftWidth: 1, borderLeftStyle: 'solid', borderLeftColor: '#666666'}}>
          <Text> </Text>
          <Text> </Text>
          <View style={{borderWidth: border, width: 70}}>
            <Text
              style={styles.linkBlack}
              onPress={() => Linking.openURL('mailto:marcioseno@hotmail.com')}
            >
              E-mail
            </Text>
          </View>
          <View style={{borderWidth: border, width: 90}}>
            <Text
              style={styles.linkBlack}
              onPress={() => Linking.openURL('http://bit.ly/3hVEwlY')}
            >
              WhatsApp
            </Text>
          </View>
          <View style={{borderWidth: border, width: 90}}>
            <Text
              style={styles.linkBlack}
              onPress={() => Linking.openURL('tel:${+5511999029313}')}
            >
              Telefone
            </Text>
          </View>
          <Text> </Text>
          <View style={{borderWidth: border, width: 80}}>
            <Text
              style={styles.link}
              onPress={() => Linking.openURL('https://www.linkedin.com/company/marcio-adriano-seno-aulas-particulares')}
            >
              LinkedIn
            </Text>
          </View>
          <View style={{borderWidth: border, width: 70}}>
            <Text
              style={styles.link}
              onPress={() => Linking.openURL('https://twitter.com/marcioseno')}
            >
              Twitter
            </Text>
          </View>
          <View style={{borderWidth: border, width: 90}}>
            <Text
              style={styles.link}
              onPress={() => Linking.openURL('https://www.instagram.com/marcioseno')}
            >
              Instagram
            </Text>
          </View>
          <View style={{borderWidth: border, width: 90}}>
            <Text
              style={styles.link}
              onPress={() => Linking.openURL('https://www.facebook.com/professoralphaville')}
            >
              Facebook
            </Text>
          </View>
          <View style={{borderWidth: border, width: 60}}>
            <Text
              style={styles.link}
              onPress={() => Linking.openURL('https://www.tiktok.com/@marcioseno')}
            >
              TikTok
            </Text>
          </View>
          <Text> </Text>
          <Text> </Text>
        </View>
      </View>
    </View>
  )
};
export default Resumo;
